export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOGFIN01.cfb7af7d.mp3";